import { KEY_ALIAS_MAP, PREFIX_STRIP_REGEXP } from '../constant';

export const normalizeKeyCode = (event: KeyboardEvent) => {
  const { code, ctrlKey, metaKey, altKey, shiftKey } = event;

  if (
    code.startsWith('Control') ||
    code.startsWith('Shift') ||
    code.startsWith('Alt') ||
    code.startsWith('Meta')
  ) {
    return null;
  }

  const parts = [];

  if (ctrlKey) parts.push('ctrl');
  if (metaKey) parts.push('cmd');
  if (altKey) parts.push('alt');
  if (shiftKey) parts.push('shift');

  let keyName = code;

  if (Object.hasOwn(KEY_ALIAS_MAP, code)) {
    keyName = KEY_ALIAS_MAP[code as keyof typeof KEY_ALIAS_MAP];
  } else if (code.match(PREFIX_STRIP_REGEXP)) {
    keyName = keyName.replace(PREFIX_STRIP_REGEXP, '').toLowerCase();
  } else {
    keyName = code.toLowerCase();
  }

  parts.push(keyName);

  return parts.join('+');
};
